import { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { getDashboardSummary } from '../../services';

function getErrorMessage(error) {
  return error.response?.data?.error || error.response?.data?.message || error.message || 'Request failed';
}

function Badge({ color, children }) {
  const colorClass = {
    yellow: 'bg-yellow-100 text-yellow-700',
    green: 'bg-green-100 text-green-700',
    blue: 'bg-blue-100 text-blue-700',
    red: 'bg-red-100 text-red-700',
  }[color];

  return <span className={`rounded px-2 py-0.5 text-sm ${colorClass}`}>{children}</span>;
}

export default function SummaryCards({ activeTab, onSelectTab }) {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    getDashboardSummary()
      .then(setSummary)
      .catch((error) => toast.error(getErrorMessage(error)));
  }, []);

  if (!summary) {
    return null;
  }

  function cardClass(tabKey) {
    return `flex min-w-[220px] cursor-pointer flex-col rounded-lg border-2 bg-white p-6 shadow ${
      activeTab === tabKey ? 'border-blue-500' : 'border-transparent'
    }`;
  }

  return (
    <div className="mb-4 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
      <div className="flex min-w-[220px] flex-col rounded-lg bg-white p-6 shadow">
        <div className="mb-2 text-lg font-bold">Tổng nợ</div>
        <div className="mb-1 text-2xl font-extrabold text-blue-700">
          {(summary.debt.total_debt * 25000).toLocaleString('en-US', {maximumFractionDigits: 0})}đ
        </div>
        <div className="text-sm text-gray-700">
          <span className="font-semibold">Nợ balance: </span>
          <span className="font-bold text-blue-700">${summary.debt.balance_debt.toLocaleString()}</span>
        </div>
        <div className="text-sm text-gray-700">
          <span className="font-semibold">Nợ Subs: </span>
          <span className="font-bold text-blue-700">${summary.debt.subscriptions_debt.toLocaleString()}</span>
        </div>
      </div>

      <div className={cardClass('users')} onClick={() => onSelectTab('users')}>
        <div className="mb-2 text-lg font-bold">Users</div>
        <div className="mb-1 flex items-end gap-2">
          <span className="text-2xl font-extrabold text-blue-700">{summary.users.total}</span>
          <span className="text-sm text-gray-500">total</span>
        </div>
        <div className="flex flex-wrap gap-2">
          <Badge color="green">
            Verified: <span className="font-bold">{summary.users.verified}</span>
          </Badge>
        </div>
      </div>

      <div className={cardClass('deposits')} onClick={() => onSelectTab('deposits')}>
        <div className="mb-2 text-lg font-bold">Deposits</div>
        <div className="mb-1 flex items-end gap-2">
          <span className="text-2xl font-extrabold text-blue-700">{summary.deposits.total}</span>
          <span className="text-sm text-gray-500">total</span>
        </div>
        <div className="flex flex-wrap gap-2">
          <Badge color="yellow">
            Pending: <span className="font-bold">{summary.deposits.pending}</span>
          </Badge>
          <Badge color="green">
            Verified: <span className="font-bold">{summary.deposits.success}</span>
          </Badge>
        </div>
      </div>

      <div className={cardClass('subscriptions')} onClick={() => onSelectTab('subscriptions')}>
        <div className="mb-2 text-lg font-bold">Subscriptions</div>
        <div className="mb-1 flex items-end gap-2">
          <span className="text-2xl font-extrabold text-blue-700">{summary.subscriptions.total}</span>
          <span className="text-sm text-gray-500">total</span>
        </div>
        <div className="flex flex-wrap gap-2">
          <Badge color="green">
            Freemium: <span className="font-bold">{summary.subscriptions.freemium}</span>
          </Badge>
          <Badge color="blue">
            Paid: <span className="font-bold">{summary.subscriptions.paid}</span>
          </Badge>
        </div>
      </div>

      <div className={cardClass('payments')} onClick={() => onSelectTab('payments')}>
        <div className="mb-2 text-lg font-bold">Payments</div>
        <div className="mb-1 flex items-end gap-2">
          <span className="text-2xl font-extrabold text-blue-700">{summary.payments.total}</span>
          <span className="text-sm text-gray-500">total</span>
        </div>
        <div className="flex flex-wrap gap-2">
          <Badge color="blue">
            Tổng tiền: <span className="font-bold">${summary.payments.total_amount.toLocaleString()}</span>
          </Badge>
        </div>
      </div>
    </div>
  );
}
